import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class ExcelManagerService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getAllFilesData(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.ALL_FILE_LIST}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getFileData(filename, page, pageSize, search): Observable<any> {
    const params = new HttpParams()
      .set('filename', filename.toString())
      .set('page', page)
      .set('page_size', pageSize)
      .set('search_value', search)
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.FILE_DATA}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  
  postFileData(filename, page, pageSize, search, headerFilters): Observable<any> {
    const params = new HttpParams()
      .set('filename', filename.toString())
      .set('page', page)
      .set('page_size', pageSize)
      .set('search_value', search);

    const body = {
      search_dict_value: headerFilters
    };

    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.FILE_DATA}`,
      body,
      { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }


  ExcelUpdateUsage(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.FILE_UPDATE_USAGE}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  ExcelUpdateValue(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.FILE_UPDATE_VALUE}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  DownloadExcelFile(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.DOWNLOAD_EXCEL_DB}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  RenameExcelFilename(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.RENAME_EXCEL}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  UploadCostingExcel(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_MANAGER.UPLOAD_EXCEL_FILE}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
